import React from 'react';
import ReactDOM from 'react-dom';

import './i18n';
import './styles/styles.scss';
import './utils/themer';

import App from './components/App';

ReactDOM.render(<App />, document.getElementById('root'));
